import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import * as policiesApi from "@/services/policiesApi";
import { SoftwareUpdateWizard } from "@/components/software-updates/wizard/SoftwareUpdateWizard";
import { fromPolicy } from "@/components/software-updates/wizard/serialize";

export default function EditSoftwareUpdatePolicyPage() {
  const { id = "" } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ["policy", id],
    queryFn: () => policiesApi.getPolicy(id),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin mr-2" /> Loading policy…
      </div>
    );
  }
  if (error || !data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-2 text-muted-foreground">
        <p>Couldn't load this policy.</p>
        <button className="underline" onClick={() => navigate("/software-updates?tab=policies")}>
          Back to Software Updates
        </button>
      </div>
    );
  }
  return <SoftwareUpdateWizard policyId={id} initial={fromPolicy(data)} />;
}
